import { Users } from '@platform/client';
import ProfileDropdown from '../dashboard/ProfileDropdown';
import { Link } from 'wouter';
import { ROUTES } from '../routes/consts';
import Skeleton from 'react-loading-skeleton';
import clsx from 'classix';
import FlexibleLink from '../util/FlexibleLink';
import dataTestids from '../constants/test-ids';
import OrganizationDropdown from '../dashboard/OrganizationDropdown';
import getDashboardSubHeaderText from './getDashboardSubHeaderText';
/**
 * The top navbar just below the main site blue navbar, containing the user's organization name, logo, and user dropdown
 */
const PageSubHeader = () => {
  const { data: user } = Users.useGetCurrentUser();

  const { navLogo, navText, cohortUrl, cohortDisplayName } = getDashboardSubHeaderText(user);

  return (
    <div className='sticky top-[var(--navbar-height)] z-40 md:relative md:top-auto bg-white px-4 lg:px-10 py-2 flex gap-2 md:gap-4 min-w-0 md:h-[var(--navbar-height)] items-center border-b-2 border-b-gray-100 whitespace-nowrap'>
      <Link className='group' to={ROUTES.DASHBOARD}>
        <div className='flex gap-2.5 items-center'>
          {/* Render image url variant of Nav Logo */}
          {navLogo && typeof navLogo === 'string' && (
            <img
              className='overflow-hidden'
              width='50'
              height='50'
              src={navLogo ?? ''}
              alt='user-plan-partner-logo'
              data-testid={dataTestids.DASHBOARD.NAVBAR.LOGO}
            />
          )}
          {/* Render JSX variant of Nav Logo */}
          {navLogo && typeof navLogo === 'object' && navLogo}
          {navText && (
            <span
              className={clsx(
                'text-xl font-open font-bold underline-offset-[6px] decoration-2 group-hover:underline',
                user?.plan.name === 'transform' && 'font-transform',
              )}
              data-testid={dataTestids.DASHBOARD.NAVBAR.TEXT}
            >
              {user ? navText : <Skeleton width={300} />}
            </span>
          )}
        </div>
      </Link>
      <div className='ml-auto flex min-w-0 flex-col md:flex-row md:gap-2 items-start md:items-center'>
        {cohortDisplayName &&
          (cohortUrl ?
            <FlexibleLink
              className='font-bold underline-offset-8 decoration-2 hover:underline'
              href={cohortUrl}
              type='external'
            >
              {cohortDisplayName} Cohort
            </FlexibleLink>
          : `${cohortDisplayName} Cohort`)}
        {user?.accountType === 'organization' && <OrganizationDropdown />}
        <ProfileDropdown />
      </div>
    </div>
  );
};

export default PageSubHeader;
